import http from '../../node_modules/fe-infrastractures/src/utils/http';


export const submitContact = (data) => {
  return http.post('/anon/worker/contact-submit', data, { loading: false, useBody: true });
};



